<template>
  <div class="growth-wizard-completed">
    <component
      :is="completionScreenComponent"
      v-bind="getCompletionScreenProps()"
    />
  </div>
</template>

<script>
import { COMPLETION_SCREEN_COMPONENTS } from '~/components/growth_wizard/completion_screens/mapping.js';

export default {
  name: 'GrowthWizardCompletionScreen',
  props: {
    organization: {
      type: Object,
      required: true,
    },
    completionScreenData: {
      type: Object,
      default: () => ({}),
    },
    completionScreenTemplate: {
      type: String,
      default: '',
    },
  },
  computed: {
    completionScreenComponentsMap() {
      return COMPLETION_SCREEN_COMPONENTS;
    },
    completionScreenComponent() {
      const componentsMap = this.completionScreenComponentsMap;

      return componentsMap[this.completionScreenTemplate]?.component;
    },
  },
  methods: {
    getCompletionScreenProps() {
      const config = this.completionScreenComponentsMap[this.completionScreenTemplate];

      return config ? config.getProps(this) : {};
    },
  },
};
</script>
